import { AiOutlineStop } from 'react-icons/ai';
import { FaQuestion } from 'react-icons/fa6';
import { IoCheckmarkCircleOutline, IoFlashOutline, IoHourglassOutline, IoPeopleOutline } from 'react-icons/io5';

import { colors } from 'styles/theme/themeCore';

import { RequestStatus } from '../../../cip/_openapi/portfolio-optimizer';

export const investmentRequestStatusToIcon = (investmentRequestStatus: RequestStatus, selected?: boolean) => {
    switch (investmentRequestStatus) {
        case RequestStatus.NEW:
            return <IoFlashOutline size={22} color={selected ? colors.gold0 : colors.cocoa400} />;
        case RequestStatus.IN_PROGRESS:
            return <IoHourglassOutline size={22} color={selected ? colors.gold0 : colors.cocoa800} />;
        case RequestStatus.PENDING_DELIVERY:
            return <IoPeopleOutline size={22} color={selected ? colors.gold0 : colors.cocoa800} />;
        case RequestStatus.COMPLETED:
            return <IoCheckmarkCircleOutline size={22} color={selected ? colors.gold0 : colors.green500} />;
        case RequestStatus.CANCELLED:
            return <AiOutlineStop size={22} color={selected ? colors.gold0 : colors.red400} />;
        default:
            return <FaQuestion size={22} color={selected ? colors.gold0 : colors.cocoa800} />;
    }
};
